import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateEventInput } from '../../../shared/models/calendar/create-event.input';
import { CalendarComuService } from '../../../shared/services/calendar/calendar-comu.service';
import { CalendarService } from '../../../shared/services/calendar/calendar.service';
import { ToastService } from '../../../shared/services/utils/toast.service';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';

@Component({
  selector: 'ngx-calendar-modal',
  templateUrl: './calendar-modal.component.html',
  styleUrls: []
})
export class CalendarModalComponent implements AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;

  sending = false;
  leadId: string;
  inCall: boolean;
  needConfirm: boolean;
  createEventInput: any;
  confirmAction: boolean;
  userId: any;
  returnedCalendarSubscribe: any;
  errorNoEvent = true;
  alive = true;
  eventAddedSubscription: any;
  returnDataSubscription: any;
  eventRemovedSubscription: any;

  constructor(private readonly modalsHandler: ModalsHandlerService,
    private readonly modalService: NgbModal,
    private readonly calendarEvent: CalendarService,
    private readonly leadComuService: LeadsComunicationService,
    private readonly toasterService: ToastService,
    private readonly calendarComuService: CalendarComuService) { }

  ngAfterViewInit(): void {
    this.modalsHandler.calendarModal.subscribe(calendarData => {
      this.errorNoEvent = true;
      this.alive = true;
      this.eventAddedSubscription = this.calendarComuService.eventAdded.subscribe(() => {
        this.errorNoEvent = false;
      });
      this.eventRemovedSubscription = this.calendarComuService.removeEvent.subscribe(() => {
        this.needConfirm = false;
        this.errorNoEvent = true;
      });
      this.returnDataSubscription = this.calendarComuService.returnedCalendarData.subscribe((dataReturnedCalendar: any) => {
        if (dataReturnedCalendar) {
          this.createEventInput = new CreateEventInput();
          this.createEventInput.leadId = this.leadId;
          this.createEventInput.dateFrom = dataReturnedCalendar.dateFrom.toDate();
          this.createEventInput.userId = dataReturnedCalendar.userId;
          this.createEventInput.text = dataReturnedCalendar.comment;
          this.createEventInput.type = dataReturnedCalendar.type;
          if (dataReturnedCalendar.userId === this.userId) {
            this.sendCreateEvent(this.createEventInput);
          } else {
            this.needConfirm = true;
          }
        } else {
          this.errorNoEvent = true;
        }
      });
      this.needConfirm = false;
      this.confirmAction = false;
      this.leadId = calendarData.leadId;
      this.inCall = calendarData.inCall;
      this.userId = calendarData.userId;
      this.modalService
        .open(this.content, {
          size: 'lg',
          container: 'nb-layout',
          ariaLabelledBy: 'modal-basic-title',
          backdrop: 'static', keyboard: false,
          windowClass: 'modal-xl'
        })
        .result
        .finally(() => {
          this.eventAddedSubscription.unsubscribe();
          this.returnDataSubscription.unsubscribe();
          this.eventRemovedSubscription.unsubscribe();
        });
      });
  }

  sendCreateEvent(createEventInput: CreateEventInput): void {
    this.sending = true;
    this.calendarEvent.createEvent$(createEventInput).subscribe(() => {
      this.modalService.dismissAll();

      this.leadComuService.launchReloadMyLead(this.leadId);
      this.toasterService
        .showToast(
          'success',
          'toaster.title.lead_reminder_success',
          'toaster.lead_reminder_success'
        );
      this.sending = false;
    });
  }
  confirmCreateEvent(): void {
    this.sendCreateEvent(this.createEventInput);
  }
  createEvent(): void {
    this.calendarComuService.getDataCalendarEvent.emit();
  }
}
